import {
  normalizeGa4Countries,
  type Ga4CountryRow,
  type SupportedCountryAnalytics,
} from "./country-analytics.ts";
import { WORLD_COUNTRY_NUMERIC_IDS } from "./world-geography.ts";

export interface WorldVisitorsModel {
  readonly mapped: readonly SupportedCountryAnalytics[];
  readonly boundaryUnavailable: readonly SupportedCountryAnalytics[];
  readonly unmapped: ReturnType<typeof normalizeGa4Countries>["unmapped"];
  readonly totalVisitors: number;
  readonly mapVisitors: number;
  readonly boundaryUnavailableVisitors: number;
  readonly unmappedVisitors: number;
}

function visitorTotal(
  countries: readonly { readonly visitors: number }[],
): number {
  return countries.reduce((total, country) => total + country.visitors, 0);
}

export function buildWorldVisitorsModel(
  rows: readonly Ga4CountryRow[],
): WorldVisitorsModel {
  const normalized = normalizeGa4Countries(rows);
  const mapped = normalized.supported.filter((country) =>
    WORLD_COUNTRY_NUMERIC_IDS.has(country.numeric),
  );
  const boundaryUnavailable = normalized.supported.filter(
    (country) => !WORLD_COUNTRY_NUMERIC_IDS.has(country.numeric),
  );
  const mapVisitors = visitorTotal(mapped);
  const boundaryUnavailableVisitors = visitorTotal(boundaryUnavailable);
  const reconciledTotal =
    mapVisitors + boundaryUnavailableVisitors + normalized.unmappedVisitors;

  if (reconciledTotal !== normalized.totalVisitors) {
    throw new Error("world_visitor_total_mismatch");
  }

  return Object.freeze({
    mapped: Object.freeze(mapped),
    boundaryUnavailable: Object.freeze(boundaryUnavailable),
    unmapped: normalized.unmapped,
    totalVisitors: normalized.totalVisitors,
    mapVisitors,
    boundaryUnavailableVisitors,
    unmappedVisitors: normalized.unmappedVisitors,
  });
}
